package com.yogaaicoach.common.ui.components

import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.ClassName

// Pixel-matched against LoadingIndicator.kt's LoadingScreen(): Box.fillMaxSize() centered,
// containing only a CircularProgressIndicator (default size 40dp, primary color, no text). Used
// both for DashboardMode.TrainingCreationInProgress and the initial "page not loaded yet" state,
// same as the real DashboardScreen.kt calls this same composable in both places.
internal val LoadingPage = FC<Props> {
    div {
        className = ClassName("loading-overlay")
        div { className = ClassName("page-spinner") }
    }
}
